import { render, staticRenderFns } from "./DateFormat.vue?vue&type=template&id=4d2fca4e&scoped=true&"
import script from "./DateFormat.vue?vue&type=script&lang=js&"
export * from "./DateFormat.vue?vue&type=script&lang=js&"
import style0 from "./DateFormat.vue?vue&type=style&index=0&id=4d2fca4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fca4e",
  null
  
)

export default component.exports